import { render, staticRenderFns } from "./SettingsLabels.vue?vue&type=template&id=6aaf5514&scoped=true"
import script from "./SettingsLabels.vue?vue&type=script&lang=js"
export * from "./SettingsLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaf5514",
  null
  
)

export default component.exports